/*@ngInject*/
const UpdateStatusReasonRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateStatusReason = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/UpdateStatusReason',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('updateStatusReasonRepository', UpdateStatusReasonRepository);
